const INFO = {
	main: {
		title: "Ankit Singh Yadav | Backend Engineer & WhatsApp Automation Expert",
		name: "Ankit Singh Yadav",
		email: "ankitsinghyadav.official@gmail.com",
		logo: "/profile.jpeg",
		resumeLink: "#", // Replace with actual resume URL
	},

	socials: {
		github: "https://github.com/ankitsyadav",
		linkedin: "https://www.linkedin.com/in/ankit-singh-yadav-a0883022b/",
		instagram: "https://www.instagram.com/professor__ankit/",
		facebook: "https://www.facebook.com/exam.portal.asy/",
	},

	homepage: {
		title: "Building Scalable Systems & WhatsApp Automation for Real Businesses",
		subtitle: "Backend Engineer · WhatsApp Automation Expert · DevOps",
		description:
			"4+ years shipping production-grade backend systems, fintech APIs, and 80+ WhatsApp automation bots. I bridge engineering excellence with real-world business automation.",
	},

	stats: [
		{ value: "4+", label: "Years Experience" },
		{ value: "80+", label: "WhatsApp Bots Built" },
		{ value: "200+", label: "Students Mentored" },
		{ value: "<200ms", label: "API Latency Achieved" },
	],

	techStack: [
		{ name: "Node.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" },
		{ name: "JavaScript", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" },
		{ name: "TypeScript", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg" },
		{ name: "React", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" },
		{ name: "AWS", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-plain-wordmark.svg" },
		{ name: "Docker", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg" },
		{ name: "Kubernetes", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg" },
		{ name: "Terraform", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/terraform/terraform-original.svg" },
		{ name: "MongoDB", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" },
		{ name: "PostgreSQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" },
		{ name: "Redis", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg" },
		{ name: "Nginx", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nginx/nginx-original.svg" },
		{ name: "Git", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" },
		{ name: "Linux", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linux/linux-original.svg" },
		{ name: "GitHub Actions", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg" },
		{ name: "Python", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" },
	],

	skills: {
		Backend: [
			"Node.js", "Express.js", "REST APIs", "GraphQL",
			"Microservices", "WebSockets", "Authentication",
			"Message Queues", "Caching (Redis)", "Database Design",
		],
		DevOps: [
			"AWS (EC2, ECS, S3, Fargate)", "Docker", "Kubernetes",
			"Terraform", "CI/CD Pipelines", "GitHub Actions",
			"Nginx", "Linux Administration", "Monitoring & Logging",
			"Infrastructure as Code",
		],
		Frontend: [
			"React.js", "JavaScript (ES6+)", "TypeScript",
			"HTML5 & CSS3", "Responsive Design", "EJS Templates",
		],
		"WhatsApp Automation": [
			"WhatsApp Business API",
			"Uchat / Wati.io",
			"Chatbot Flow Design",
			"Lead & Inquiry Automation",
			"FAQ Bot Development",
			"Appointment Booking Bots",
			"B2B Workflow Automation",
			"Broadcast & Campaign Bots",
		],
	},

	education: [
		{
			institution: "Army Public School",
			degree: "Senior Secondary (12th)",
			location: "India",
			note: "",
		},
		{
			institution: "Pune University",
			degree: "B.Sc. Physics",
			location: "Pune",
			note: "With Distinction",
		},
		{
			institution: "MJPRU (Mahatma Jyotiba Phule Rohilkhand University)",
			degree: "M.A. Economics",
			location: "Bareilly",
			note: "NTA NET Qualified — 2 Times",
		},
	],

	experience: [
		{
			company: "EduFund",
			location: "India",
			role: "Product Engineer 2",
			duration: "Mar 2026 – Present",
			logo: "/edufund.webp",
			points: [
				"Building and shipping product features for India's leading education investment platform",
				"Contributing to backend APIs, platform reliability, and product infrastructure for EdTech fintech workflows",
			],
		},
		{
			company: "Newton School of Technology",
			location: "Pune",
			role: "SDE + SME (Backend & DevOps)",
			duration: "Aug 2025 – Present",
			logo: "https://i.postimg.cc/sDFJxLdq/channels4-profile.jpg",
			points: [
				"Mentoring 200+ students across Node.js, Docker, CI/CD, and AWS — with 90%+ placement rate in cohort",
				"Designed reusable backend architecture templates adopted across 15+ student projects",
				"Built CI/CD pipelines using GitHub Actions + Docker + Nginx, reducing student deployment effort by 70%",
				"Conducted live system design sessions on microservices, caching, and fault-tolerant architectures",
			],
		},
		{
			company: "FinXBridge (with M2P Fintech)",
			location: "Hyderabad",
			role: "Software Development Engineer 1 (Backend + DevOps)",
			duration: "Jan 2025 – Aug 2025",
			logo: "https://i.postimg.cc/Bn0JnJv1/m2p-logo.png",
			points: [
				"Engineered low-latency backend services for Flipkart EMI onboarding on API Orchestration platform — processing high-volume financial transactions",
				"Achieved sub-200ms API latency under peak production traffic via optimized middleware and DB query tuning",
				"Built fault-tolerant microservices for Mercedes-Benz Financial Services LOS with retry logic, validations, and audit trails",
			],
		},
		{
			company: "Hey Homie",
			location: "Remote",
			role: "Backend Engineer (SDE 1)",
			duration: "Nov 2022 – Jan 2025",
			logo: "https://i.postimg.cc/9FcNRDF6/1640436028142.jpg",
			points: [
				"Architected and deployed 80+ WhatsApp automation bots for B2B client workflows handling 10,000+ messages/day",
				"Built custom Node.js + Google Apps Script automation tools, saving 20+ manual hours/week for operations teams",
				"Optimized MongoDB schemas and aggregation pipelines, improving query performance by 50% on high-traffic collections",
				"Implemented real-time monitoring dashboards tracking bot health, delivery rates, and conversation metrics",
			],
		},
		{
			company: "Subhadra Devi Mularam Krishak Mahavidyalaya",
			location: "Noogohi, Shahjahanpur",
			role: "Assistant Professor",
			duration: "Jan 2022 – Nov 2022",
			logo: "",
			points: [
				"Delivered undergraduate Economics curriculum to 100+ students at Shahjahanpur college",
				"Qualified NTA NET examination twice — demonstrating strong subject matter expertise in Economics",
			],
		},
	],

	testimonials: [
		{
			quote: "Ankit is one of the most dedicated backend engineers I've worked with. His ability to design scalable systems and mentor juniors is exceptional.",
			name: "Tech Lead",
			role: "FinXBridge / M2P Fintech",
			image: "/profile.jpeg",
		},
		{
			quote: "His DevOps expertise helped us reduce our deployment time by over 70%. Ankit brings both deep technical skills and great communication to every team.",
			name: "Engineering Manager",
			role: "Newton School of Technology",
			image: "/profile.jpeg",
		},
		{
			quote: "Working with Ankit on our WhatsApp automation infrastructure was a game-changer. He delivered reliable systems that handled thousands of messages daily.",
			name: "Product Manager",
			role: "Hey Homie",
			image: "/profile.jpeg",
		},
	],

	about: {
		title: "Backend Engineer, WhatsApp Automation Expert & Mentor",
		description: `I am a Backend Engineer and WhatsApp Automation Expert with 4+ years of experience building production-grade systems — from fintech APIs to 80+ WhatsApp bots handling 10,000+ messages daily.

My WhatsApp automation work spans B2B workflow automation, lead capture bots, FAQ automation, and appointment booking systems — built using Wati.io, Uchat, and Node.js integrations. I have helped businesses automate their customer communication at a fraction of the cost of enterprise tools.

On the engineering side, I build scalable microservices, low-latency APIs, and fintech workflows. I have deployed and maintained production systems on AWS using EC2, S3, ECS, and Fargate — working with Docker, Kubernetes, Terraform, GitHub Actions, and Nginx.

Currently at EduFund as Product Engineer 2, building product features for India's leading education investment platform. Previously at FinXBridge (with M2P Fintech), where I achieved sub-200ms API latency on Flipkart EMI onboarding flows.

Before transitioning into software engineering, I completed a B.Sc. in Physics (With Distinction) from Pune University and an M.A. in Economics from MJPRU, Bareilly — qualifying the NTA NET examination twice. I also served as an Assistant Professor of Economics, which sharpened my ability to explain complex systems clearly and mentor others effectively.

I mentor 200+ students at Newton School of Technology on Node.js, DevOps, and cloud deployments — and I am building Taiyari Express to bring WhatsApp automation to small Indian businesses at ₹499/month.`,
	},

	initiatives: [
		{
			name: "Taiyari Express",
			tagline: "WhatsApp Automation for Local Businesses",
			description:
				"I believe every small business in India deserves to look professional and never miss a customer — not just the ones who can afford expensive software. Taiyari Express is my attempt to make that possible. Simple WhatsApp automation, no technical setup, no Meta API, no GST hassle. Just pay ₹499/month and we handle everything.",
			vision:
				"Helping small Indian businesses grow by giving them tools that big brands already use — at a price that makes sense for them.",
			price: "₹499/month",
			link: "/taiyari-express",
			status: "Live",
			targets: ["Salons", "Clinics", "Coaching Institutes", "Boutiques", "Gyms", "Local Shops"],
			features: [
				"Automated WhatsApp Replies",
				"FAQ Automation",
				"Inquiry & Lead Collection",
				"Appointment Request Handling",
				"No Technical Setup Needed",
			],
		},
	],

	projects: [
		{
			title: "URL Uptime & Status Monitoring System",
			description:
				"A backend-focused monitoring system built using Node.js with EJS-based server-side rendering. Performs scheduled URL health checks, tracks uptime and HTTP status codes, and logs downtime events.",
			logo: "/proj-monitor.svg",
			linkText: "View Project",
			link: "https://swiftcheck-fft8.onrender.com/dashboard",
			tags: ["Backend", "Monitoring"],
			techStack: ["Node.js", "EJS", "MongoDB"],
			featured: true,
		},
		{
			title: "Taiyari Express - Exam Preparation Platform",
			description:
				"A comprehensive exam preparation platform offering practice tests and study materials for competitive exams. Features detailed performance analytics and progress tracking.",
			logo: "/proj-edtech.svg",
			linkText: "View Project",
			link: "https://www.taiyari-express.in/",
			tags: ["Frontend", "EdTech"],
			techStack: ["React", "JavaScript"],
			featured: true,
		},
		{
			title: "Smoke Limited - AI Smoking Pattern Analyzer",
			description:
				"Behavioral analytics web app tracking cigarette consumption and identifying smoking triggers using AI-driven insights. Features time-based pattern detection and intelligent feedback via Puter.js.",
			logo: "/proj-smoke.svg",
			linkText: "View Project",
			link: "https://smoke-limited.onrender.com/",
			tags: ["Backend", "AI"],
			techStack: ["Node.js", "EJS", "Puter.js"],
			featured: false,
		},
	],
};

export default INFO;
